/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Draft_Total_VatInputs */

const vi_einvoice_draft_total_vat = /** @type {(inputs: Einvoice_Draft_Total_VatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tổng VAT`)
};

/**

* @param {Einvoice_Draft_Total_VatInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_draft_total_vat = /** @type {((inputs?: Einvoice_Draft_Total_VatInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Draft_Total_VatInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_draft_total_vat(inputs)
});